import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';

import flagIcon from '../../../assets/missions/flag (3).png';
import targetIcon from '../../../assets/missions/target.png';
import watchIcon from '../../../assets/missions/watch.png';
import dexterityIcon from '../../../assets/missions/Dexterity_2.png';
import disciplineIcon from '../../../assets/missions/discipline.png';
import intelligenceIcon from '../../../assets/missions/Intelligence.png';

import Modal from '../../Modal';

import api from '../../../services/api';

import { useAuth } from '../../../hooks/AuthContext';

import { Container, Checkbox } from './styles';
import Loader from '../../Loader';

const MissionCard = ({ id, owner, title, goal, duration, skill, skillIcon, period, status, recomendation, childId, isFitbitGoal }) => {
  const { user } = useAuth();
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);

  const token = localStorage.getItem("@Ocariot:token");

  const validate = (missionId, childId) => {
    setLoading(true);
    api.put(`/parent/validate/${childId}/${missionId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      setLoading(false);
      toast.success('Missão validada com sucesso');
      setToggleModal(false);
      document.location.reload();
    }).catch((err) => {
      setLoading(false);
      toast.error("Erro ao validar missão");
      console.log(err.response);
    });
  }

  return (
    <Container>
      <Modal
        width={400}
        height={240}
        show={toggleModal}
        onClose={() => setToggleModal(false)}
      >
        <div className="validate-modal">
          <h2>Confirmar validação</h2>
          <p>Tem certeza que deseja validar a missão <strong>'{title}'</strong>?</p>
          <p>Uma vez que a missão for validada não será possível alterar seu status.</p>
          <div className="footer-buttons">
            <button onClick={() => setToggleModal(false)}>Cancelar</button>
            <button onClick={() => validate(id, childId)}>
              {loading ? <Loader color="white" /> : 'Validar'}
            </button>
          </div>
        </div>
      </Modal>
      <div className="left-side">
        <strong>Proprietário</strong>
        <p>{owner}</p>
      </div>
      <div className="middle-side">
        <div className="first-line">
          <img src={flagIcon} alt="" />
          <div className="mission-title">
            <strong>{title}</strong>
            <p>{recomendation}</p>
          </div>
        </div>

        <div className="details-line">
          <div className="goal">
            <img src={targetIcon} alt="" />
            <div className="flex-detail">
              <strong>Objetivo</strong>
              <p>{goal}.</p>
            </div>
          </div>

          <div className="duration">
            <img src={watchIcon} alt="" />
            <div className="flex-detail">
              <strong>Duração</strong>
              <p>{duration} dia(s).</p>
            </div>
          </div>

          <div className="skill">
            <img 
            src={(skillIcon === "Inteligência") ? intelligenceIcon : (skillIcon === "Disciplina") ? disciplineIcon : dexterityIcon} 
            alt="" 
            />
            <div className="flex-detail">
              <strong>Habilidade</strong>
              <p>{skill}.</p>
            </div>
          </div>
        </div>

      </div>

      <div className="right-side">
        <div>
          <strong>Período Ativo</strong>
          <p>{period}</p>
        </div>

        <div className="status-div">
          <strong>Estado</strong>
          <p>{status}</p>
        </div>
        {(user.type == 1 && status === "Concluída" && !isFitbitGoal) && (
          <div className="validate-mission">
            <strong>Validar missão:</strong>
            <Checkbox isActive={isActive} onClick={() => setToggleModal(true)}>
              {isActive && <FaCheck color="#fff" size={18} />}
            </Checkbox>
          </div>
        )}
      </div>
    </Container>
  );
}

export default MissionCard;